export const defaultDashboard = {
  Name: '',
  HiddenPrimaryColumnsIds: [],
  SelectedCustomColumns: [],
}

export const ACTUAL_CONTENTS_DEFAULT_DASHBOARD_ID = 0
export const DELETED_CONTENTS_DEFAULT_DASHBOARD_ID = -1
